import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useEffect } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { formatUserType, isNotEmpty } from '../../../utils/format';
import QueryKey from '../../../utils/QueryKey';
import { getUserDDForAssignServ } from '../../../services/com-service';
import { customAlert, notify } from '../../../components/notify';
import CustomDropDown from '../../../components/CustomDropDown';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { assignProjUserServ } from '../../../services/proj-service';

const userTypeArr = [
    { value: "line_manager", label: "Contract Owner" },
    { value: "focal_point", label: "Contract Focal Point" }];

function AssignProjUser({ modalOpen, handleModalClose, userType, comId, projData }) {
    const theme = useTheme();
    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();

    const queryClient = useQueryClient();
    const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }

    const [selection, setSelection] = useState({ });

    const { isLoading, isError, error, data: userData } = useQuery([QueryKey.comAssiUserDD, comId, userType],
        () => getUserDDForAssignServ(comId, userType),
        {
            enabled: (isNotEmpty(comId) && isNotEmpty(userType)),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            retry: false,
        })

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);



    function handleDDChange(e) {
        const { name, value } = e.target;
       
        setSelection((e) => { return { ...e, [name]: value } });
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                comId,
                userId: isNotEmpty(selection.userId) ? selection.userId : null,
                projIdStrg: projData?.projIdStrg
            }
            const { message } = await assignProjUserServ(payload);
            queryClient.invalidateQueries();
            notify("success", message);
            handleModalClose()
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    function validate(values) {
        const errors = {};
        if (!values.userId)
            errors.userId = "Employee is required!";
        return errors;
    };


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack alignItems={"center"} mb={2.5}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)" }}>Assign Employee</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <LabelTxtFieldInfo readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} name="project"
                            defaultValue={`${projData?.projName} (${projData?.actProjIdStrg})`} title="Project" {...txtFieldSx} />
                        <CustomDropDown readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} name="userType"
                            defaultValue={userType} errMsg={formErrors.userType} title={"Employee Role"} {...txtFieldSx} ddArr={userTypeArr} />
                        <CustomDropDown name="userId" title={`Employees (${formatUserType(userType)}) *`} errMsg={formErrors.userId}
                            {...txtFieldSx} handleDDChange={handleDDChange} ddArr={userData?.empArr || []} />


                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  
                            CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> 
                            ASSIGN</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form>
        </Modal>
    )
}

export default AssignProjUser;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 3,
    py: 2,
    borderRadius: 2,
    height: "54%"
};